import { Component, Input, OnInit } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-certificate-of-origin',
  templateUrl: './certificate-of-origin.component.html',
  styleUrls: ['./certificate-of-origin.component.scss']
})
export class CertificateOfOriginComponent implements OnInit {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  settings: any = null;
  logoUrl: string = '';

  constructor(private _globalService: GlobalStateService) {}

  ngOnInit(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
      this.logoUrl = res.logo || '';
    });
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatRegDate(year: string | null | undefined, month: string | null | undefined): string {
    if (!year) return '-';
    return month ? `${year}/${month.toString().padStart(2, '0')}` : year;
  }
}
